export interface Title {
  id: string;
  title: string;
  type: 'movie' | 'tv';
  year: number;
  region: string;
  genres: string[];
  rating: number;
  poster: string;
  synopsis: string;
  director: string;
  cast: string[];
  duration?: string;
  status?: 'ongoing' | 'completed';
  episodes?: number;
  updatedAt: string;
}

export const genreOptions = ['动作', '爱情', '喜剧', '悬疑', '科幻', '古装', '都市', '惊悚', '动画', '剧情'];

export const regionOptions = ['大陆', '美国', '韩国', '日本', '香港', '英国'];

export const yearOptions = [2025, 2024, 2023, 2022, 2021];

export const titles: Title[] = [
  {
    id: 'changye-zhuiguang',
    title: '长夜追光',
    type: 'movie',
    year: 2024,
    region: '大陆',
    genres: ['悬疑', '剧情'],
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%2C%20lone%20detective%20silhouette%20in%20rainy%20neon%20alley%20at%20night%2C%20deep%20blue%20and%20amber%20tones%2C%20moody%20dramatic%20lighting%2C%20vertical%20poster%20composition%2C%20no%20text&width=400&height=600&seq=qx-poster-01&orientation=portrait',
    synopsis: '一桩跨越十五年的悬案，让刑警与受害者家属被命运紧紧捆绑。为了追寻真相，他们必须在漫长的黑夜里彼此照亮。',
    director: '陈仕远',
    cast: ['林川', '周晚', '高楠', '许清和'],
    duration: '128分钟',
    updatedAt: '2024-11-02',
  },
  {
    id: 'xinghai-jiyuan',
    title: '星海纪元',
    type: 'movie',
    year: 2025,
    region: '美国',
    genres: ['科幻', '动作'],
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20movie%20poster%2C%20vast%20galaxy%20with%20spaceship%20silhouette%2C%20cool%20blue%20and%20orange%20nebula%2C%20futuristic%20atmosphere%2C%20cinematic%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-02&orientation=portrait',
    synopsis: '人类舰队驶向未知星系，一场关乎文明存续的远征就此展开。面对浩瀚星海，他们寻找的是家园，还是自己的答案？',
    director: 'Ethan Cole',
    cast: ['Marcus Lee', 'Nora Vance', 'Ivan Petrov'],
    duration: '146分钟',
    updatedAt: '2025-01-18',
  },
  {
    id: 'shanhai-miwu',
    title: '山海秘闻录',
    type: 'tv',
    year: 2025,
    region: '大陆',
    genres: ['古装', '悬疑'],
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20poster%2C%20traditional%20scroll%20art%20style%2C%20mountains%20and%20mist%2C%20mystical%20beasts%2C%20ink%20and%20warm%20amber%20tones%2C%20vertical%20cinematic%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-03&orientation=portrait',
    synopsis: '古籍中记载的山海异兽接连现身人间，年轻的勘舆师与同伴踏上寻秘之旅，揭开一段被尘封千年的往事。',
    director: '顾长风',
    cast: ['沈砚', '白薇', '陆知远', '程依'],
    status: 'ongoing',
    episodes: 32,
    updatedAt: '2025-03-12',
  },
  {
    id: 'chengnan-jiushi',
    title: '城南旧事季',
    type: 'tv',
    year: 2024,
    region: '大陆',
    genres: ['都市', '爱情'],
    rating: 7.6,
    poster: 'https://readdy.ai/api/search-image?query=Warm%20urban%20romance%20drama%20poster%2C%20old%20town%20street%20with%20golden%20sunset%2C%20warm%20orange%20and%20cream%20tones%2C%20nostalgic%20cozy%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-04&orientation=portrait',
    synopsis: '城南的一条老街上，三代人的悲欢交错展开。时光流转，唯有那些细碎的温情始终留在原地。',
    director: '苏婉如',
    cast: ['江雨桐', '贺明', '罗佳'],
    status: 'completed',
    episodes: 40,
    updatedAt: '2024-09-20',
  },
  {
    id: 'nizhan-fengbao',
    title: '逆战风暴',
    type: 'movie',
    year: 2023,
    region: '香港',
    genres: ['动作', '悬疑'],
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20poster%2C%20explosive%20street%20chase%20at%20night%2C%20deep%20blue%20and%20orange%20flames%2C%20gritty%20cinematic%20lighting%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-05&orientation=portrait',
    synopsis: '一名卧底警探在身份暴露后遭到两面追捕，他必须在一个夜晚之内，用一场逆袭来洗清自己的污名。',
    director: '麦伟成',
    cast: ['郑浩南', 'Will Chan', '苏晴'],
    duration: '118分钟',
    updatedAt: '2023-12-05',
  },
  {
    id: 'yinghua-wuyu',
    title: '樱花物语',
    type: 'movie',
    year: 2024,
    region: '日本',
    genres: ['爱情', '剧情'],
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Gentle%20Japanese%20romance%20film%20poster%2C%20cherry%20blossom%20path%20with%20soft%20petals%2C%20pale%20pink%20and%20cream%20tones%2C%20dreamy%20bokeh%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-06&orientation=portrait',
    synopsis: '每年樱花盛开时，她都会回到那家小小的旧书店。今年，书店的门口多了一个陌生又熟悉的身影。',
    director: '小林启介',
    cast: ['佐藤凛', '中村优', '高桥澪'],
    duration: '112分钟',
    updatedAt: '2024-04-10',
  },
  {
    id: 'quanli-migong',
    title: '权力迷宫',
    type: 'tv',
    year: 2025,
    region: '美国',
    genres: ['悬疑', '剧情'],
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Political%20thriller%20series%20poster%2C%20shadowy%20corridor%20with%20light%20beam%2C%20deep%20navy%20and%20gold%20accents%2C%20tense%20dramatic%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-07&orientation=portrait',
    synopsis: '一场突如其来的权力更迭，让华盛顿的权力走廊暗流涌动。每个人都戴着面具，没有人知道谁才是真正的棋手。',
    director: 'Daniel Frost',
    cast: ['Robert Hale', 'Elena Marsh', 'Tom Brio'],
    status: 'ongoing',
    episodes: 12,
    updatedAt: '2025-02-28',
  },
  {
    id: 'gudao-mihang',
    title: '孤岛迷航',
    type: 'movie',
    year: 2025,
    region: '韩国',
    genres: ['惊悚', '剧情'],
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Tense%20survival%20thriller%20movie%20poster%2C%20stormy%20isolated%20island%20with%20lighthouse%2C%20cold%20blue%20and%20grey%20tones%2C%20ominous%20atmosphere%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-08&orientation=portrait',
    synopsis: '一场海难后，七名幸存者被困在无人的孤岛上。当救援迟迟未至，人性中最真实的一面开始显露。',
    director: '朴俊赫',
    cast: ['李成宇', '金恩菲', '崔志勋'],
    duration: '134分钟',
    updatedAt: '2025-01-30',
  },
  {
    id: 'xingchen-dadao',
    title: '星辰大道',
    type: 'tv',
    year: 2024,
    region: '大陆',
    genres: ['科幻', '都市'],
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Modern%20sci-fi%20drama%20poster%2C%20cityscape%20at%20dusk%20with%20data%20light%20streams%2C%20deep%20blue%20and%20cyan%20glow%2C%20clean%20futuristic%20look%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-09&orientation=portrait',
    synopsis: '当人工智能开始理解情感，一座城市也随之改变。工程师与她的造物之间，悄然生长出超越代码的羁绊。',
    director: '柳青禾',
    cast: ['方哲', '温以宁', '郭屹'],
    status: 'ongoing',
    episodes: 24,
    updatedAt: '2024-12-15',
  },
  {
    id: 'xiaozhen-qtan',
    title: '小镇奇谈',
    type: 'movie',
    year: 2023,
    region: '大陆',
    genres: ['喜剧', '剧情'],
    rating: 7.4,
    poster: 'https://readdy.ai/api/search-image?query=Warm%20comedic%20drama%20movie%20poster%2C%20small%20town%20square%20at%20evening%2C%20cozy%20orange%20and%20teal%20tones%2C%20lively%20charming%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-10&orientation=portrait',
    synopsis: '为了保住镇上唯一的老电影院，一群看似不着调的居民，策划了一场令人捧腹又热泪盈眶的"大计划"。',
    director: '何家树',
    cast: ['王小舟', '刘慧', '孙大壮'],
    duration: '106分钟',
    updatedAt: '2023-10-12',
  },
  {
    id: 'wuying-zhe',
    title: '无影者',
    type: 'tv',
    year: 2025,
    region: '香港',
    genres: ['悬疑', '动作'],
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Neo-noir%20crime%20series%20poster%2C%20lone%20figure%20backlit%20in%20foggy%20harbor%2C%20cold%20blue%20and%20amber%20streetlight%2C%20sleek%20moody%20look%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-11&orientation=portrait',
    synopsis: '一名身份成谜的网络安全专家，与重案组探员联手，追踪一个在暗网上几乎"不存在"的犯罪集团。',
    director: '邓家豪',
    cast: ['陈子谦', '何韵', '麦志朗'],
    status: 'ongoing',
    episodes: 20,
    updatedAt: '2025-03-20',
  },
  {
    id: 'huohua-shaonian',
    title: '火花少年',
    type: 'movie',
    year: 2024,
    region: '日本',
    genres: ['动画', '剧情'],
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20film%20poster%2C%20boy%20and%20girl%20on%20rooftop%20under%20fireworks%2C%20warm%20amber%20and%20deep%20blue%20sky%2C%20painterly%20art%20style%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-12&orientation=portrait',
    synopsis: '小镇的夏天，两个怀揣梦想的少年偶然相遇。他们用一场烟火，点亮了彼此最灿烂也最短暂的一个季节。',
    director: '新海真一',
    cast: ['花泽遥', '神谷凛'],
    duration: '98分钟',
    updatedAt: '2024-08-22',
  },
  {
    id: 'xingfu-lai-ling',
    title: '幸福来临',
    type: 'tv',
    year: 2024,
    region: '大陆',
    genres: ['都市', '喜剧'],
    rating: 7.7,
    poster: 'https://readdy.ai/api/search-image?query=Bright%20urban%20comedy%20drama%20poster%2C%20sunny%20apartment%20balcony%20with%20plants%2C%20fresh%20green%20and%20warm%20cream%20tones%2C%20cheerful%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-13&orientation=portrait',
    synopsis: '三个性格迥异的合租室友，一间总在出状况的老公寓。鸡飞狗跳的日常里，藏着最动人的生活温度。',
    director: '林可可',
    cast: ['赵晓棠', '钱多多', '吴屿'],
    status: 'completed',
    episodes: 36,
    updatedAt: '2024-07-08',
  },
  {
    id: 'fengren-shoujiren',
    title: '风暴守望者',
    type: 'movie',
    year: 2025,
    region: '美国',
    genres: ['动作', '惊悚'],
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Storm%20chaser%20action%20movie%20poster%2C%20massive%20tornado%20over%20plains%2C%20dramatic%20grey%20and%20orange%20sky%2C%20epic%20cinematic%20scale%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-14&orientation=portrait',
    synopsis: '一名气象学家带领团队深入超级风暴中心，只为抢在灾难降临前，给千万人争取最后的撤离时间。',
    director: 'Sam Reynolds',
    cast: ['Jack Doyle', 'Mia Cole', 'Louis Grant'],
    duration: '124分钟',
    updatedAt: '2025-02-10',
  },
  {
    id: 'gudai-yizhen',
    title: '古代疑案录',
    type: 'tv',
    year: 2023,
    region: '大陆',
    genres: ['古装', '悬疑'],
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20detective%20drama%20poster%2C%20traditional%20courtyard%20at%20night%20with%20lanterns%2C%20deep%20red%20and%20ink%20blue%20tones%2C%20elegant%20mysterious%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-15&orientation=portrait',
    synopsis: '新科状元被卷入一桩离奇命案，他凭过人智识与仵作少女搭档，一路抽丝剥茧，揭开层层迷局。',
    director: '温子修',
    cast: ['裴砚之', '叶轻眉', '赵守仁'],
    status: 'completed',
    episodes: 30,
    updatedAt: '2023-06-18',
  },
  {
    id: 'xianggang-zhige',
    title: '香港之夜',
    type: 'movie',
    year: 2022,
    region: '香港',
    genres: ['动作', '剧情'],
    rating: 7.5,
    poster: 'https://readdy.ai/api/search-image?query=Neon%20Hong%20Kong%20night%20movie%20poster%2C%20rainy%20street%20with%20colorful%20signs%2C%20deep%20blue%20and%20warm%20orange%20neon%2C%20cinematic%20reflective%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-16&orientation=portrait',
    synopsis: '午夜的中环，两个素不相识的陌生人因为一场意外相遇。一夜之间，他们替彼此解开了多年心结。',
    director: '梁家辉',
    cast: ['陈国栋', '林嘉欣', '吴镇业'],
    duration: '110分钟',
    updatedAt: '2022-11-25',
  },
  {
    id: 'shiguang-yuanming',
    title: '时光缘铭',
    type: 'tv',
    year: 2025,
    region: '韩国',
    genres: ['爱情', '剧情'],
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20drama%20poster%2C%20couple%20under%20glowing%20clock%20tower%20in%20snow%2C%20soft%20blue%20and%20golden%20tones%2C%20tender%20dreamy%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-17&orientation=portrait',
    synopsis: '一块能让人回到过去的旧怀表，将两个相隔二十年的人联系在了一起。他们能改变命运，却改变不了思念。',
    director: '金敏秀',
    cast: ['李书俊', '韩智恩', '朴恩星'],
    status: 'ongoing',
    episodes: 16,
    updatedAt: '2025-03-05',
  },
  {
    id: 'zhengjiu-xingqiu',
    title: '拯救星球',
    type: 'movie',
    year: 2024,
    region: '英国',
    genres: ['科幻', '剧情'],
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Thoughtful%20sci-fi%20drama%20poster%2C%20astronaut%20looking%20at%20earth%20from%20orbit%2C%20deep%20teal%20and%20soft%20gold%2C%20contemplative%20epic%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-18&orientation=portrait',
    synopsis: '地球资源濒临枯竭，一支国际科考队前往遥远行星寻找答案。在浩瀚宇宙里，人类最该拯救的或许是自己。',
    director: 'Oliver Hayes',
    cast: ['Emma Ward', 'James Nolan', 'Sophie Kent'],
    duration: '138分钟',
    updatedAt: '2024-10-30',
  },
  {
    id: 'mishi-tantou',
    title: '密室谈判',
    type: 'movie',
    year: 2023,
    region: '韩国',
    genres: ['悬疑', '惊悚'],
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Tense%20single%20room%20thriller%20poster%2C%20long%20interrogation%20table%20with%20hanging%20lamp%2C%20cold%20grey%20and%20amber%20tones%2C%20claustrophobic%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-19&orientation=portrait',
    synopsis: '谈判专家与连环嫌犯在一个封闭房间里对峙八小时。每一句话都是陷阱，每一个沉默都藏着真相。',
    director: '尹相宇',
    cast: ['姜泰勋', 'Min Seo', '赵明宰'],
    duration: '102分钟',
    updatedAt: '2023-03-16',
  },
  {
    id: 'dushi-jiaobu',
    title: '都市脚步',
    type: 'tv',
    year: 2024,
    region: '大陆',
    genres: ['都市', '剧情'],
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Modern%20workplace%20drama%20poster%2C%20young%20people%20walking%20in%20city%20morning%20light%2C%20clean%20blue%20and%20cream%20tones%2C%20motivational%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-20&orientation=portrait',
    synopsis: '四个刚刚踏入职场的年轻人，在大城市里跌跌撞撞地成长。关于梦想、妥协与不肯认输的每一步。',
    director: '高文博',
    cast: ['李沐阳', '全思洁', '范文迪', '徐一诺'],
    status: 'completed',
    episodes: 28,
    updatedAt: '2024-05-11',
  },
  {
    id: 'shenhai-lieren',
    title: '深海猎刃',
    type: 'movie',
    year: 2025,
    region: '美国',
    genres: ['动作', '惊悚'],
    rating: 7.6,
    poster: 'https://readdy.ai/api/search-image?query=Underwater%20action%20thriller%20movie%20poster%2C%20submarine%20in%20deep%20dark%20ocean%2C%20deep%20blue%20and%20teal%20glow%2C%20suspenseful%20cold%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-21&orientation=portrait',
    synopsis: '一艘深潜潜艇在万米海底失联，精英小队奉命潜入搜救，却发现幽暗深处潜伏着远超想象的危险。',
    director: 'Chris Palmer',
    cast: ['Derek Sun', 'Lara Kim', 'Otto Berg'],
    duration: '120分钟',
    updatedAt: '2025-01-08',
  },
  {
    id: 'qingshi-huangcheng',
    title: '倾世凰城',
    type: 'tv',
    year: 2023,
    region: '大陆',
    genres: ['古装', '爱情'],
    rating: 7.7,
    poster: 'https://readdy.ai/api/search-image?query=Grand%20historical%20palace%20drama%20poster%2C%20imperial%20palace%20in%20mist%2C%20deep%20crimson%20and%20gold%20tones%2C%20elegant%20regal%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-22&orientation=portrait',
    synopsis: '将门之女被迫入宫，凭一身傲骨在步步惊心的深宫里周旋。她要守的不只是家族荣辱，更是一段被辜负的深情。',
    director: '云舒',
    cast: ['苏锦书', '萧珩', '白知微'],
    status: 'completed',
    episodes: 44,
    updatedAt: '2023-08-30',
  },
  {
    id: 'weilai-jiaoshi',
    title: '未来教师',
    type: 'tv',
    year: 2025,
    region: '日本',
    genres: ['科幻', '都市'],
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Futuristic%20school%20drama%20poster%2C%20classroom%20with%20holographic%20screens%2C%20clean%20blue%20and%20warm%20amber%20tones%2C%20hopeful%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-23&orientation=portrait',
    synopsis: '一位来自未来的教师被派往当下，只为阻止一个即将改变世界的孩子走上歧途。教育，竟成了最惊险的任务。',
    director: '冈田纯',
    cast: ['松山翔', '石川玲', '宫本凛'],
    status: 'ongoing',
    episodes: 18,
    updatedAt: '2025-03-18',
  },
  {
    id: 'pengyou-yiqilai',
    title: '朋友们一起来',
    type: 'movie',
    year: 2024,
    region: '大陆',
    genres: ['喜剧', '剧情'],
    rating: 7.3,
    poster: 'https://readdy.ai/api/search-image?query=Feel-good%20comedy%20movie%20poster%2C%20group%20of%20friends%20laughing%20on%20road%20trip%2C%20bright%20orange%20and%20sky%20blue%20tones%2C%20joyful%20energetic%20mood%2C%20vertical%20poster%2C%20no%20text&width=400&height=600&seq=qx-poster-24&orientation=portrait',
    synopsis: '四个三十岁的老友决定重走青春时的那条路。一路上笑料百出，也终于和那个莽撞又勇敢的自己握了手。',
    director: '马跃',
    cast: ['周小北', '姚然', '陈嘉树', '林思'],
    duration: '104分钟',
    updatedAt: '2024-06-24',
  },
];

export default titles;